











































































































































































import { Vue, Component, Prop, p } from "av-ts";
import { IComment, ICourseUser, IQuestion } from "../../interfaces/models";
import QuestionService from "../../services/QuestionService";

Vue.directive("focus-on-create", {
    inserted: function(el) {
        Vue.nextTick(function() {
            el.focus();
        });
    }
});

@Component()
export default class Comment extends Vue {
    @Prop questionID = p<number>({
        required: true
    });

    @Prop comment = p<IComment>({
        required: true
    });

    @Prop user = p<ICourseUser>({
        required: true
    });

    showAuthComment: number = 0;
    editComment: number = 0;

    upvote(id: number) {
        QuestionService.upvoteComment(this.questionID, id).then(x=>this.refreshLikes(x));
    }

    edit(id: number) {
        this.showAuthComment = 0;
        this.editComment = id;
    }

    deleteC() {
        return;
    }


    reply(id: number) {
        this.editComment = 0;
        this.showAuthComment = id;
    }

    newInput(e: KeyboardEvent) {
        if (e.keyCode === 13 && !e.shiftKey) {
            let content = (<HTMLInputElement>document.getElementById("subCommentText"))!.value;
            content = content.trim();
            if (content.length > 0) {
                QuestionService.submitComment(this.questionID, this.comment.id, content)
                    .then(x=>this.refreshComments(x));
                this.showAuthComment = 0;
            }
        }
    }

    editInput(e: KeyboardEvent) {
        if (e.keyCode === 13 && !e.shiftKey) {
            let content = (<HTMLInputElement>document.getElementById("subCommentText"))!.value;
            content = content.trim();
            if (content.length > 0) {
                QuestionService.editComment(this.questionID, this.editComment, content)
                    .then(x=>this.refreshComments(x));
                this.editComment = 0;
            }
        }
    }

    refreshComments(question: IQuestion) {
        this.$emit("refresh", question, true);
    }

    refreshLikes(question: IQuestion) {
        this.$emit("refresh", question, false);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/Comment.vue